import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { refreshView as refreshViewAction } from "ra-core";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import SendIcon from "@material-ui/icons/Send";
import { HOST } from "../../configs/index";
import { sendRepairToLine } from "../../services";


const styles = theme => ({
	container: {
		display: "flex",
		flexWrap: "wrap",
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
	},
});

const mapStateToProps = state => ({

});
const enhance = connect(
	mapStateToProps,
	{ refreshView: refreshViewAction }
);
const DialogSelect = enhance(
	class DialogSelect extends React.Component {
		state = {
			open: false,
			group: "",
			choices: [],
			disable: true
		};

		isPressSent = false;

		componentDidMount() {
			const { isSent, status } = this.props;
			// this.setState({ disable: !(status === 4 && !isSent)  });
			// this.setState({ disable: isSent });
			const token = localStorage.getItem("token");
			const { project } = this.props;
			fetch(`${HOST}/line?project=${project}`, {
				headers: { authorization: `Bearer ${token}` },
			})
				.then((response) => response.json())
				.then((responseJson) => {
					this.setState({ choices: responseJson });
				});
		}

		handleChange = name => event => {
			this.setState({ [name]: event.target.value });
		};

		handleClickOpen = () => {
			this.setState({ open: true });
		};

		handleClose = () => {
			this.setState({ open: false });
		};

		onSubmit = () => {
			// this.setState({ disable: true });
			if (!this.isPressSent) {
				this.isPressSent = true;
				const { repairId } = this.props;
				const { group } = this.state;
				if (group) {
					sendRepairToLine(repairId, group);
					this.props.refreshView();
				}
				this.handleClose();
			}
		}

		render() {
			const { classes, isSent } = this.props;
			const { choices, disable } = this.state;
			return (
				<div>
					<Button
						// disabled={disable} 
						onClick={this.handleClickOpen}
						style={{ color: isSent ? "#7bba00" : "#3f51b5" }}
					// style={{ color: disable ? "rgba(0, 0, 0, 0.26)" : "#3f51b5" }}
					>
						<SendIcon style={{ marginRight: 10 }} />
						Send to Line
  					</Button>
					<Dialog
						disableBackdropClick
						disableEscapeKeyDown
						open={this.state.open}
						onClose={this.handleClose}
					>
						<DialogTitle>Select line group</DialogTitle>
						<DialogContent>
							<form className={classes.container}>
								{/* <FormControl className={classes.formControl}>
                <InputLabel htmlFor="group-native-simple">Group</InputLabel>
                <Select
                  native
                  value={this.state.group}
                  onChange={this.handleChange('group')}
                  input={<Input id="group-native-simple" />}
                >
                  <option value="" />
                  {
                    choices.map(choice => <option key={choice._id} value={String(choice._id)}>{choice.name}</option>)
                  }
                </Select>
              </FormControl> */}
								<FormControl className={classes.formControl}>
									<InputLabel htmlFor="group-simple">Group</InputLabel>
									<Select
										value={this.state.group}
										onChange={this.handleChange("group")}
										input={<Input id="group-simple" />}
									>
										<MenuItem value="">
											<em></em>
										</MenuItem>
										{
											choices.map(choice => <MenuItem key={choice._id} value={choice.key}>{choice.name}</MenuItem>)
										}
										{/* <MenuItem value={"10"}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem> */}
									</Select>
								</FormControl>
							</form>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleClose} color="primary">
								Cancel
  					</Button>
							<Button onClick={this.onSubmit} color="primary">
								Ok
  					</Button>
						</DialogActions>
					</Dialog>
				</div>
			);
		}
	}
);


DialogSelect.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DialogSelect);


// WEBPACK FOOTER //
// ./src/components/repair/LineAction.js